module.exports = __webpack_public_path__ + "static/media/seats_v1.0.2af3cc76.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/seats_v1.0.png
// module id = 52
// module chunks = 0